import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=07bbfa6e&"
import script from "./Sidebar.controller.js?vue&type=script&lang=js&"
export * from "./Sidebar.controller.js?vue&type=script&lang=js&"
import style0 from "./Sidebar.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports